const TelemetryIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="100%"
            height="100%"
            viewBox="-0.5 -0.5 600 634"
        >
            <defs />
            <g>
                <image
                    x="-147"
                    y="-0.5"
                    width="900"
                    height="634"
                    xlinkHref="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iNzIwLjAwMDAwMHB0IiBoZWlnaHQ9IjUwNy4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDcyMC4wMDAwMDAgNTA3LjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgoKPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsNTA3LjAwMDAwMCkgc2NhbGUoMC4xMDAwMDAsLTAuMTAwMDAwKSIKZmlsbD0iIzJBNEU2OSIgc3Ryb2tlPSJub25lIj4KPHBhdGggZD0iTTI1NDQgNDY1NiBjLTE3IC04IC00NCAtMzEgLTYwIC01MiBsLTI5IC0zNyAwIC0yMDMyIDAgLTIwMzIgMjkgLTM3CmM1MyAtNzAgLTEzIC02NiAxMTE2IC02NiAxMTI5IDAgMTA2MyAtNCAxMTE2IDY2IGwyOSAzNyAwIDIwMzIgMCAyMDMyIC0yOSAzNwpjLTUzIDcwIDEzIDY2IC0xMTE4IDY2IC04MzkgLTEgLTEwMjkgLTMgLTEwNTQgLTE0eiBtMTkzNCAtODU4IGwyIC01NDggLTg4MAowIC04ODAgMCAwIDU0NCBjMCA0MjYgMyA1NDUgMTMgNTQ5IDYgMyA0MDEgNCA4NzcgMyBsODY1IC0xIDMgLTU0N3ogbS03NDEKLTE4MTkgYzk5IC00OCAxNTMgLTEzMCAxNjEgLTI0NSA2IC0xMDEgLTE2IC0xNjMgLTgyIC0yMzAgLTEyNiAtMTI2IC0zMTEKLTEyNSAtNDMzIDIgLTY2IDY5IC04NyAxMjkgLTgxIDIyOCA2IDgxIDI4IDEzMiA4MyAxODkgOTQgOTcgMjIzIDExOCAzNTIgNTZ6Cm02ODMgLTExNjkgbDAgLTYwIC04MjAgMCAtODIwIDAgMCA2MCAwIDYwIDgyMCAwIDgyMCAwIDAgLTYweiIvPgo8cGF0aCBkPSJNMjgzMiA0MDQzIGwzIC0xODggNzY1IDAgNzY1IDAgMyAxODggMiAxODcgLTc3MCAwIC03NzAgMCAyIC0xODd6Ii8+CjxwYXRoIGQ9Ik0yODMwIDM1NTAgbDAgLTE5MCA3NzAgMCA3NzAgMCAtMiAxODggLTMgMTg3IC03NjcgMyAtNzY4IDIgMCAtMTkweiIvPgo8cGF0aCBkPSJNMzUxMiAxODc5IGMtMTA2IC01MyAtMTMzIC0xOTYgLTU1IC0yOTAgOTEgLTEwOCAyNjggLTc3IDMxOSA1NiA2MgoxNjIgLTEwNyAzMTEgLTI2NCAyMzR6Ii8+CjwvZz4KPC9zdmc+Cg=="
                    preserveAspectRatio="none"
                />
                <text
                    fill="#ffffff"
                    x="50%"
                    y="50%"
                    alignmentBaseline="middle"
                    textAnchor="middle"
                    fontSize="50"
                    fontWeight="600"
                    fontStyle="italic"
                >
                    Telemetry
                </text>
            </g>
        </svg>
    );
};

export default TelemetryIcon;
